import { render, staticRenderFns } from "./item618.vue?vue&type=template&id=18d72b1b&scoped=true"
import script from "./item618.vue?vue&type=script&lang=js"
export * from "./item618.vue?vue&type=script&lang=js"
import style0 from "./item618.vue?vue&type=style&index=0&id=18d72b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d72b1b",
  null
  
)

export default component.exports